/**
 * Created by Thomas Mark
 * Date: 28.05.2019
 * Description: textarea-Widget - Mehrzeilige Texteingabe
 *
 * Das textarea-Widget bietet die Möglichkeit einen längeren mehrzeiligen Text einzugeben.
 * Für einzeiligen Text steht das text-Widget zur Verfügung.
 *
 * Die Steuerung des Widgets basiert auf folgender Widget-Struktur:
 *
 "fields": [
    {
        "id": "description",
        "length": 2000,
        "label": "Description",
        "unitLabel": "",
        "description": "Full Description of the Object",
        "placeholder": "enter full description",
        "widget": "textarea",
        "maxItems": 100,
        "visibleItems": 5,
        "group": null,
        "value": 'lorem ipsum lorem ipsum lorem ipsum lorem ipsum',
        "enums": []
        "validation": "^[A-Za-z0-9äöüÄÖÜß!\?\.\-§$%&\/\*\+#()_ ]*$",
        "validationState": null,
        "validationMessage": "Description contains invalid characters!"
    },
 *
 * Im textarea-Widget stehen folgende Widget-Attribute zur Verfügung:
 *
 * id            - Identifizierung des Feldes (muss eindeutig sein)
 * length        - Länge des Textes bzw. Anzahl Zeichen
 * label         - Bezeichnung, die links neben dem Widget erscheint
 * unitLabel     - Mengeneinheit, die rechts neben dem Widget erscheint
 * description   - Genauere Beschreibung des Feldes, wird bei klick auf das Fragezeichen angezeigt
 * placeholder   - Text der im Eingabefeld erscheint, solange noch kein Wert eingegeben wurde
 * widget        - Bezeichnung des Widgets. Hier mit "textarea" belegt
 * maxItems      - Maximale Anzahl Zeilen
 * visibleItems  - Sichtbare Zeilen. Existieren weitere Zeilen, so erscheint ein vertikaler Scrollbalken
 * group         - Gruppenzuordnung (siehe dialog.group)
 * value         - Aktueller Text
 * enums         - Alle Auswahlmöglichkeiten (hier ohne Bedeutung)
 * validation    - RegEx zur Validierung des Textes
 * validationState   - Zustand der Validierung
 * validationMessage - Fehlermeldung, falls Validierung erfolglos
 *
 * Der Komponente können folgende Eigenschaften/Werte übergeben werden:
 * field  - field-Object
 * value  - aktueller Wert
 * type   - input-type. Wird an das input-Tag weitergeleitet
 * icon   - Bezeichnung des Icons, das rechts neben dem Eingabefeld erscheint.
 * onChange - callback-Funktion. Wird aufgerufen, wenn sich der Wert im Feld verändert
 * onKeyPress - callback-Funktion. Wird aufgerufen, wenn eine Taste gedrückt wurde
 * onBlur - callback-Funktion. Wird aufgerufen, wenn das Feld verlassen wird
 *
 */
import React from 'react';

const Textarea = ({ field, value, onChange, onKeyPress, onBlur }) => {

    const rows = field['rows'] ? field.rows : null;
    const length = field['length'] ? field.length + 1 : null;
    const disabled = field['disabled'] ? field.disabled : false;
    const placeholder = field['placeholder'] ? field.placeholder : null;

    return (

        <textarea
            className="bg-gray-200 appearance-none rounded h-full w-full px-2 py-2 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
            id={field.id}
            value={value}
            disabled={disabled}
            size={length}
            rows={rows}
            placeholder={placeholder}
            maxLength={length}
            onChange={(e) => onChange(e, e.target.value)}
            onKeyPress={onKeyPress}
            onBlur={onBlur}>
        </textarea>
    )
};

export default Textarea